import React, { useState, useReducer } from "react";
import { useIntl } from "react-intl";
import makeStyles from "@material-ui/core/styles/makeStyles";
import RegularForm from "./components/regular-form";
import {
  LOGIN_ACTION_FINISH_SUBMIT,
  LOGIN_ACTION_HANDLE_SUBMIT,
  LOGIN_ACTION_START_SUBMIT,
  LOGIN_STATUS_USER_PASSWORD,
} from "./login-form-constants";
import { lfLoginRequest } from "../../authProvider";
import { store } from "../../store";
import { setAlertAction } from "../../reducers";
import CustomAlert from "../../components/custom-alert/custom-alert";
import {
  ROLE_MAS_BRAN,
  ROUTES_HOME,
  SESSION_SECURITY_ROLE_KEY,
  SESSION_TOKEN_STORAGE_KEY,
  SESSION_USER_ID_KEY,
  SESSION_USER_TENANTS_KEY,
} from "../../utils/constants";
import { useNavigate } from "react-router";
import { checkSessionService } from "../../api";

const initialState = {
  loading: false,
  loginRes: { loginPhase: { status: LOGIN_STATUS_USER_PASSWORD } },
};

const reducer = (state, { type, payload }) => {
  switch (type) {
    case LOGIN_ACTION_START_SUBMIT:
      return {
        ...state,
        loading: true,
      };

    case LOGIN_ACTION_HANDLE_SUBMIT:
      return {
        ...state,
        loginRes: payload.loginRes,
      };

    case LOGIN_ACTION_FINISH_SUBMIT:
      return {
        ...state,
        loading: false,
      };

    default:
      throw new Error();
  }
};

const useStyles = makeStyles((theme) => ({
  loginButton: { ...theme.classes.mainButton, width: 100, height: 36, marginTop: theme.spacing(2) },
  input: {
    border: "0.5px solid #444",
    height: theme.spacing(6),
    width: 230,
    padding: theme.spacing(0, 0.5),
    fontSize: "1rem",
  },
  etiqueta: {
    fontSize: "1rem",
    marginRight: theme.spacing(4),
    color: "black !important",
  },
  etiquetaPinDest: {
    marginTop: "10px",
  },
  formRows: {
    marginBottom: "10px",
  },
  posRelative: {
    position: "relative",
    clear: "both",
    width: "100%",
    height: "70px",
  },
  btnSubmit: {
    minWidth: "101.375px",
    color: "white",
    margin: ".5rem",
    textTransform: "lowercase",
    fontWeight: "bold",
  },
  submitMessage: {
    marginLeft: ".5rem",
  },
  spin: {
    color: "black",
    animation: "$spin 2500ms infinite linear",
  },
  buttonArea: {
    marginTop: "2rem",
  },
  "@keyframes spin": {
    from: {
      transform: "rotate(360deg)",
    },
    to: {
      transform: "rotate(0deg)",
    },
  },
  pinOption: {
    display: "flex",
    margin: "10px",
  },
  otpPinDests: {
    borderLeft: "1px black dotted",
  },
  pinSelectInput: {
    marginRight: "8px",
  },
  confirmPinDest: {
    marginTop: "20px",
  },
  alert: {
    marginBottom: "30px",
  },
}));

const LoginForm = () => {
  const classes = useStyles();
  const intl = useIntl();
  const navigate = useNavigate();

  const [{ loading }, dispatch] = useReducer(reducer, initialState);

  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");

  const loginErrorCallback = (e) => {
    dispatch({ type: LOGIN_ACTION_FINISH_SUBMIT });
    const message = e?.logMessage || e?.userMessage;
    store.dispatch(setAlertAction(true, false, e?.errorCode ?? null, "", message ?? ""));
  };

  const loginCallback = (response) => {
    if (+response.errorCode === -1) {
      const message = response.logMessage || response.userMessage;
      store.dispatch(setAlertAction(true, false, response.errorCode, "", message));
      dispatch({ type: LOGIN_ACTION_FINISH_SUBMIT });
      return;
    }

    const roles = JSON.stringify(response.roles);
    const hasMasBranRole = roles.includes(ROLE_MAS_BRAN);

    if (!hasMasBranRole) {
      dispatch({ type: LOGIN_ACTION_FINISH_SUBMIT });
      store.dispatch(
        setAlertAction(true, false, response.errorCode, "", intl.formatMessage({ id: "roles_mas_bran_not_allowed" })),
      );
      return;
    }

    dispatch({ type: LOGIN_ACTION_FINISH_SUBMIT });
    sessionStorage.setItem(SESSION_TOKEN_STORAGE_KEY, response.sessionToken);
    sessionStorage.setItem(SESSION_USER_TENANTS_KEY, JSON.stringify(response.tenants));
    sessionStorage.setItem(SESSION_USER_ID_KEY, response.userId);
    sessionStorage.setItem(SESSION_SECURITY_ROLE_KEY, roles);
    navigate(ROUTES_HOME);
    checkSessionService();
  };

  const submit = (e) => {
    e.preventDefault();
    dispatch({ type: LOGIN_ACTION_START_SUBMIT });

    const base_params = {
      username,
      password,
    };

    lfLoginRequest(base_params).then(loginCallback).catch(loginErrorCallback);
  };

  const handleSetPassword = (value) => {
    setPassword(value);
  };

  const handleSetUserName = (value) => {
    setUserName(value);
  };

  return (
    <div>
      <form onSubmit={submit}>
        <RegularForm
          classes={classes}
          intl={intl}
          username={username}
          handleSetUserName={handleSetUserName}
          password={password}
          handleSetPassword={handleSetPassword}
          loading={loading}
        />
      </form>
      <CustomAlert />
    </div>
  );
};

export default LoginForm;
